"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var MobileDrawer_1 = __importDefault(require("./MobileDrawer"));
var MobileHeader_1 = __importDefault(require("./MobileHeader"));
var MobileContainer = function (_a) {
    var _b = _a.routerObj, routerPush = _b.routerPush, routerRoutes = _b.routerRoutes, testRoute = _b.testRoute, multipleBanksObj = _a.multipleBanksObj, logoutUrl = _a.logoutUrl;
    var _c = __read((0, react_1.useState)(false), 2), navOpen = _c[0], setNavOpen = _c[1];
    var handleNavigation = function (url) { return function (e) {
        if (routerPush && routerRoutes.some(testRoute(url))) {
            e.preventDefault();
            routerPush(url);
        }
        setNavOpen(false);
    }; };
    var selectIdentity = function (_, identity) {
        if (typeof identity !== 'string') {
            var url = "/profile/".concat(identity.identityUuid);
            if (routerPush && routerRoutes.some(testRoute(url))) {
                routerPush(url);
            }
            else {
                window.location.assign(url);
            }
        }
        setNavOpen(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(MobileDrawer_1.default, { navObj: { navOpen: navOpen, setNavOpen: setNavOpen }, handleNavigation: handleNavigation, multipleBanksObj: multipleBanksObj, logoutUrl: logoutUrl, handleonChange: selectIdentity }),
        react_1.default.createElement(MobileHeader_1.default, { handleNavigation: handleNavigation, setNavOpen: setNavOpen })));
};
exports.default = MobileContainer;
//# sourceMappingURL=MobileContainer.js.map